// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: FaRlVP157fG
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicPaymentsPageSidebar.module.css"; // plasmic-import: FaRlVP157fG/css
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: t-tWHZTgfh/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: QrnmMSFuM9/icon
import Layer1Icon from "./icons/PlasmicIcon__Layer1"; // plasmic-import: 5h-sORW9lL/icon
import ellipse3GnenoyRKp6 from "./images/ellipse3.svg"; // plasmic-import: gnenoyRKp6/picture

createPlasmicElementProxy;

export const PlasmicPaymentsPageSidebar__VariantProps = new Array();

export const PlasmicPaymentsPageSidebar__ArgProps = new Array(
  "contractName",
  "milestoneName",
  "amount"
);

const $$ = {};

function PlasmicPaymentsPageSidebar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"figmaPaste4"}
        data-plasmic-override={overrides.figmaPaste4}
        className={classNames(projectcss.all, sty.figmaPaste4)}
      >
        <div className={classNames(projectcss.all, sty.freeBox__pF3J8)}>
          {p.renderPlasmicSlot({
            defaultContents: "Social Media Marketing",
            value: args.contractName,
            className: classNames(sty.slotTargetContractName)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___6Amni)}>
          {p.renderPlasmicSlot({
            defaultContents: "$300.00",
            value: args.amount,
            className: classNames(sty.slotTargetAmount)
          })}
        </div>
        <div
          data-plasmic-name={"closeButton"}
          data-plasmic-override={overrides.closeButton}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.closeButton
          )}
        >
          {"X"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__aoXm1
          )}
        >
          {"Qty 1"}
        </div>
        <div
          data-plasmic-name={"milestoneNameStack"}
          data-plasmic-override={overrides.milestoneNameStack}
          className={classNames(projectcss.all, sty.milestoneNameStack)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Milestone 2: Audit and Analysis",
            value: args.milestoneName,
            className: classNames(sty.slotTargetMilestoneName)
          })}
        </div>
        <Line1Icon
          className={classNames(projectcss.all, sty.svg__ci4Sq)}
          role={"img"}
        />

        <Layer11Icon
          data-plasmic-name={"downloadContract"}
          data-plasmic-override={overrides.downloadContract}
          className={classNames(projectcss.all, sty.downloadContract)}
          role={"img"}
        />

        <div
          data-plasmic-name={"_212433597315589653811"}
          data-plasmic-override={overrides._212433597315589653811}
          className={classNames(projectcss.all, sty._212433597315589653811)}
        />

        <p.PlasmicImg
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"26px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"29px"}
          loading={"lazy"}
          src={{
            src: ellipse3GnenoyRKp6,
            fullWidth: 29,
            fullHeight: 26,
            aspectRatio: 1.115385
          }}
        />

        <div
          data-plasmic-name={"layer2"}
          data-plasmic-override={overrides.layer2}
          className={classNames(projectcss.all, sty.layer2)}
        >
          <Layer1Icon
            className={classNames(projectcss.all, sty.svg__wOmqp)}
            role={"img"}
          />
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__q8DYo
          )}
        >
          {"View Contract"}
        </div>
        <Line1Icon
          className={classNames(projectcss.all, sty.svg__wCg69)}
          role={"img"}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "figmaPaste4",
    "closeButton",
    "milestoneNameStack",
    "downloadContract",
    "_212433597315589653811",
    "img",
    "layer2"
  ],

  figmaPaste4: [
    "figmaPaste4",
    "closeButton",
    "milestoneNameStack",
    "downloadContract",
    "_212433597315589653811",
    "img",
    "layer2"
  ],

  closeButton: ["closeButton"],
  milestoneNameStack: ["milestoneNameStack"],
  downloadContract: ["downloadContract"],
  _212433597315589653811: ["_212433597315589653811"],
  img: ["img"],
  layer2: ["layer2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentsPageSidebar__ArgProps,
          internalVariantPropNames: PlasmicPaymentsPageSidebar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentsPageSidebar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentsPageSidebar";
  } else {
    func.displayName = `PlasmicPaymentsPageSidebar.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentsPageSidebar = Object.assign(
  // Top-level PlasmicPaymentsPageSidebar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    figmaPaste4: makeNodeComponent("figmaPaste4"),
    closeButton: makeNodeComponent("closeButton"),
    milestoneNameStack: makeNodeComponent("milestoneNameStack"),
    downloadContract: makeNodeComponent("downloadContract"),
    _212433597315589653811: makeNodeComponent("_212433597315589653811"),
    img: makeNodeComponent("img"),
    layer2: makeNodeComponent("layer2"),
    // Metadata about props expected for PlasmicPaymentsPageSidebar
    internalVariantProps: PlasmicPaymentsPageSidebar__VariantProps,
    internalArgProps: PlasmicPaymentsPageSidebar__ArgProps
  }
);

export default PlasmicPaymentsPageSidebar;
/* prettier-ignore-end */
